<template>
  <div class="p-2 bg-gray-50 rounded-md shadow-sm">
    <div class="flex flex-row pt-2">
      <Button class="w-96"
        v-if="!openAddEntrySection"
        color="gray"
        size="md"
        @click="createNewUserEntry">
        New User
      </Button>
      <div class="flex flex-col w-full"
        v-if="openAddEntrySection">
        <div class="grid grid-cols-9 justify-items-start">
          <TextField class="col-span-2 max-h-24 flex flex-row w-full justify-between items-center px-2"
            v-model="addEntryData.name">
            Name:
          </TextField>
          <TextField class="col-span-2 max-h-24 flex flex-row w-full justify-between items-center px-2"
            v-model="addEntryData.email">
            Email:
          </TextField>
          <Group class="col-span-2"
            :userGroupOptions="userGroupOptions"
            v-model="addEntryData.groups"
          />
          <div class="col-span-3 flex flex-col w-full">
            <ConfigSection
              v-model="addEntryData.config"
            />
          </div>
        </div>
        <div class="flex flex-row">
          <textarea class="m-2 p-2 w-[90%] h-9 text-sm"
            v-model="addEntryQuery">
          </textarea>
          <Button class="w-32 m-2"
            color="blue"
            size="sm"
            @click="addEntryToQuery">
            Add to Query
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../components/Button.vue'
import TextField from '../../components/formComponents/TextField.vue'
import ConfigSection from './ConfigSection.vue'
import Group from './Group.vue'

import userManagementService from '../../services/pages/userManagement.js'


export default {
  components: {
    Button,
    TextField,
    ConfigSection,
    Group,
  },
  props: {
    userGroupOptions: Array,
  },
  data() {
    return {
      openAddEntrySection: false,
      addEntryData: undefined,

      addEntryQuery: undefined,
    }
  },
  mounted() {
    // do nothing
  },
  methods: {
    newEntryData() {
      return {
        name: undefined,
        email: undefined,
        groups: undefined,
        config: {},
      }
    },
    createNewUserEntry() {
      this.openAddEntrySection = true
      this.addEntryData = this.newEntryData()
    },
    addEntryToQuery() {
      this.openAddEntrySection = false
      this.addEntryData = this.newEntryData()
      this.$emit('addQuery', this.addEntryQuery)
    },
  },
  watch: {
    addEntryData: {
      handler(newData) {
        let createCommand = userManagementService.createCreateUserQuery(newData.name, newData.email, newData.groups, newData.config.userConfig, newData.config.appMetadata)
        this.addEntryQuery = createCommand
      },
      deep: true,
    }
  }
}
</script>
